// Specify and initialize here bootstrap components needed by the app

import { Tooltip /*, Toast, Popover */ } from 'bootstrap';

document.addEventListener("turbolinks:load", () => {
  document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(tooltipTriggerEl => new Tooltip(tooltipTriggerEl))
})

